import axios from 'axios';
import { API_BASE_URL } from '../utils/apiConfig';

/**
 * Workshop reflections — saves Workshop "reflect" step answers and loads
 * the user's Money Bio for the profile page.
 */
class ReflectionService {
  constructor() {
    this.api = axios.create({
      baseURL: `${API_BASE_URL}/reflections`,
      headers: { 'Content-Type': 'application/json' }
    });

    this.api.interceptors.request.use((config) => {
      const token = localStorage.getItem('moneysmart-token');
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    });
  }

  async getMine() {
    const response = await this.api.get('/');
    return response.data;
  }

  async save({ lessonId, bioKey, bioLabel, question, answer, isGoal = false }) {
    const response = await this.api.post('/', { lessonId, bioKey, bioLabel, question, answer, isGoal });
    return response.data;
  }
}

export default new ReflectionService();
